<template>
  <v-app>
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data: () => ({}),
};
</script>
<style lang="scss">
@font-face {
  font-family: 'CircularPro';
  src: url('../src/assets/fonts/CircularPro-Bold.woff') format('woff'),
    url('../src/assets/fonts/CircularPro-Bold.ttf') format('truetype'),
    url('../src/assets/fonts/CircularPro-Bold.woff2') format('woff2');
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: 'CircularPro';
  src: url('../src/assets/fonts/CircularPro-Book.woff') format('woff'),
    url('../src/assets/fonts/CircularPro-Book.ttf') format('truetype'),
    url('../src/assets/fonts/CircularPro-Book.woff2') format('woff2');
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: 'CircularPro';
  src: url('../src/assets/fonts/CircularPro-Medium.woff') format('woff'),
    url('../src/assets/fonts/CircularPro-Medium.ttf') format('truetype'),
    url('../src/assets/fonts/CircularPro-Medium.woff2') format('woff2');
  font-weight: 500;
  font-style: normal;
}
#app {
  font-family: 'CircularPro';
}
h1 {
  font-size: 35px;
  letter-spacing: -0.8px;
  font-weight: bold;
  color: #17173a;
  font-family: 'CircularPro';
}
h2 {
  font-size: 24px;
  letter-spacing: -0.2px;
  font-weight: bold;
  color: #17173a;
  font-family: 'CircularPro';
}
h3 {
  font-size: 16px;
  font-weight: bold;
  color: #17173a;
  font-family: 'CircularPro';
}
h4 {
  font-size: 14px;
  font-weight: 350;
  color: #17173a;
  font-family: 'CircularPro';
}
p {
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 0;
  font-family: 'CircularPro';
}

.centered {
  display: flex;
  justify-content: center;
  align-items: center;
}
.smaller {
  font-size: 12px;
}
.book {
  font-weight: 350;
}
.lighten {
  color: #8b8b9d;
}
.color-primary {
  color: #0091ff !important;
}
.color-secondary {
  color: #d8eefe !important;
}
.color-danger {
  color: #ff808b !important;
}
.color-icon {
  color: #17173a !important;
  background-color: #eaeaf0 !important;
}

.color-white {
  color: white !important;
}

.background-primary {
  background-color: #0091ff !important;
}
.background-danger {
  background-color: #ff808b !important;
}

.background-color {
  color: #d8eefe !important;
}

.error-color {
  color: #ff808b !important;
}

.grayscale {
  filter: grayscale(100%);
  opacity: 0.5;
}

.responsive-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  @media(max-width: 1024px) {
    flex-direction: column;
  }
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0 30px white inset !important;
}


.v-btn {
  &--outlined {
    border-color: #cfcfd6 !important;
  }
  &:not(.v-btn--round) {
    &.v-size--large {
      height: 56px !important;
    }
  }
  &__content {
    text-transform: none;
  }

  &.danger {
    background: rgba(#ff808b, 0.15) !important;
  }
}

#app {
  .v-card:not(.v-sheet--tile):not(.v-card--shaped) {
    border-radius: 8px;
  }
  .v-dialog {
    box-shadow: none;

    &__close {
      position: absolute;
      right: 46px;
      top: 48px;
    }
  }
}

.animoji {
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
  width: 100%;
  height: auto;

  padding-top: 100%;

  background-color: #e9e9e9;
  border-radius: 50%;

  img {
    position: absolute;
    top: 50%;
    left: 50%;

    width: 67%;
    height: auto;
    display: block;

    transform: translate(-50%, -50%);
  }
}
</style>
